import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { nameof } from 'ts-simple-nameof';
import { DialogSubscriptionComponent } from '../../../../dialog/dialog-subscription.component';
import { DialogService } from '../../../../dialog/dialog.service';
import { GradingRule } from '../../../../shared/interface/grading-rule.interface';
import { AlertService } from '../../../../shared/services/alert.service';
import { nameofExt } from '../../../../shared/services/nameof-extend';
import { ReflectionService } from '../../../../shared/utilities/reflection.service';
import { TableStateService } from '../../../../tables/table-state.service';
import {
    ActionButtonClickEvent,
    ActionComplete, ColumnClickEvent,
    ColumnDefinition,
    TableFilterItem
} from '../../../../tables/table.types';
import { GradingRuleEditComponent } from './grading-rule-edit/grading-rule-edit.component';
import { GradingRuleService } from './grading-rule.service';

@Component({
    selector: 'app-grading-rules',
    templateUrl: './grading-rules.component.html',
    styleUrls: ['./grading-rules.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class GradingRulesComponent extends DialogSubscriptionComponent implements OnInit {
    tableName: string = 'gradingRule';
    baseUrl: string = 'gradingRule';
    gradingRuleStringInterp: string = `Grading Rule: ${nameofExt<GradingRule>((m) => m.gradeLevel)} ${nameofExt<GradingRule>(
        (m) => m.gradeMode
    )} ${nameofExt<GradingRule>((m) => m.validGrade)}`;
    filters: Array<TableFilterItem> = [
        {
            property: nameof<GradingRule>((m) => m.gradeLevel),
            inputType: 'input'
        },
        {
            property: nameof<GradingRule>((m) => m.gradeMode),
            inputType: 'input'
        },
        {
            property: nameof<GradingRule>((m) => m.validGrade),
            inputType: 'input'
        }
    ];

    columns: Array<ColumnDefinition> = [
        {
            property: nameof<GradingRule>((m) => m.id)
        },
        {
            property: nameof<GradingRule>((m) => m.gradeLevel)
        },
        {
            property: nameof<GradingRule>((m) => m.gradeMode)
        },
        {
            property: nameof<GradingRule>((m) => m.validGrade)
        },
        {
            property: nameof<GradingRule>((m) => m.isEnabled),
            booleanAsIcon: {
                trueIcon: 'radio_button_checked',
                trueToolTip: `Click to disable ${this.gradingRuleStringInterp}`,
                falseIcon: 'radio_button_unchecked',
                falseToolTip: `Click to enable ${this.gradingRuleStringInterp}`
            },
            clickCallBack: {
                this: this,
                observable: (event: ColumnClickEvent<GradingRule>) => {
                    return this.service.toggleIsEnabled(event.element.id);
                },
                function: (event: ColumnClickEvent<GradingRule>) => {
                    event.element.isEnabled = !event.element.isEnabled;
                    this.alert.toastSuccess(`Grading Rule: ${event.element.isEnabled ? 'enabled.' : 'disabled.'}`);
                    this.tableState.sendToTable({
                        tableName: this.tableName,
                        element: event.element,
                        update: true
                    });
                    return {
                        completed: true,
                        value: event.element.isEnabled
                    };
                }
            }
        },
        {
            property: nameof<GradingRule>((m) => m.lastUpdatedByName),
            headerHtml: 'Last Updated By',
            disableSort: true
        },
        {
            property: nameof<GradingRule>((m) => m.lastUpdated),
            isDate: true,
            dateFormat: 'short'
        },
        {
            property: 'actions',
            actions: [
                {
                    discriminator: 'edit',
                    icon: 'edit',
                    toolTip: `Edit ${this.gradingRuleStringInterp}`,
                    clickCallBack: {
                        this: this,
                        observable: (event: ActionButtonClickEvent<GradingRule>) => {
                            return this.service.show(event.element.id);
                        },
                        function: this.show
                    }
                },
                {
                    discriminator: 'delete',
                    icon: 'delete',
                    toolTip: `Delete ${this.gradingRuleStringInterp}`,
                    clickCallBack: {
                        this: this,
                        observable: (event: ActionButtonClickEvent<GradingRule>) => {
                            return this.service.delete(event.element.id);
                        },
                        function: (event: ActionButtonClickEvent<GradingRule>) => {
                            this.alert.toastSuccess('Grading Rule removed!');
                            this.tableState.sendToTable({
                                tableName: this.tableName,
                                element: event.element,
                                remove: true
                            });
                            return {
                                completed: true
                            };
                        }
                    }
                }
            ]
        }
    ];

    constructor(
        private service: GradingRuleService,
        private dialog: DialogService<GradingRule>,
        private tableState: TableStateService,
        private reflection: ReflectionService,
        private alert: AlertService
    ) {
        super();
    }

    ngOnInit(): void {}
    show(event: ActionButtonClickEvent<GradingRule> = null): ActionComplete {
        const element = event?.observableValue ?? {
            id: -1,
            gradeLevel: 'U'
        };
        const d = this.dialog.show(element, {
            component: GradingRuleEditComponent,
            dialogAlias: 'edit_grading_rule',
            uniqueId: `edit_grading_rule_${element.id}`,
            title:
                element.id === -1
                    ? 'New Grading Rule'
                    : this.reflection.stringDataMerge(element, this.gradingRuleStringInterp)
        });
        this.addSubscription(
            this.dialog.response.subscribe((g) => {
                if (g.dialogAlias === 'edit_grading_rule') {
                    this.tableState.sendToTable({
                        tableName: this.tableName,
                        element: g.payload,
                        update: true
                    });
                }
            }),
            d
        );

        return {
            completed: true
        };
    }
}
